export default __webpack_public_path__ + "static/media/attention-popup.3d5bb03e.svg";